import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onClose"];
import React from 'react';
import PropTypes from 'prop-types';
import { PopupStateless as LegacyStatelessPopup } from '@beef/legacy-ui-kit';
import { pushTariffOption } from "../../utils/ga";
export var PopupStateless = function PopupStateless(_ref) {
  var children = _ref.children,
    _onClose = _ref.onClose,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LegacyStatelessPopup, _extends({
    onClose: function onClose() {
      pushTariffOption('Закрыть popup');
      _onClose();
    }
  }, props, {
    "data-t-id": "components-Popup"
  }), children);
};
PopupStateless.propTypes = process.env.NODE_ENV !== "production" ? {
  onClose: PropTypes.func
} : {};
export default PopupStateless;